import { render, staticRenderFns } from "./CardOrange.vue?vue&type=template&id=c3c5bb58&"
import script from "./CardOrange.vue?vue&type=script&lang=js&"
export * from "./CardOrange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports